// Spec 093 — informations de version du frontend, injectées au build via Vite `define`.
// Replis explicites si non injectées (dev local sans stamping).

export interface VersionInfo {
  version: string
  gitSha: string
  buildTime: string
  environment: string
}

// Les globals __APP_*__ sont remplacées au build par vite.config.ts (define).
export const VERSION_INFO: VersionInfo = {
  version: __APP_VERSION__ || '0.0.0-dev',
  gitSha: __GIT_SHA__ || 'unknown',
  buildTime: __BUILD_TIME__ || 'unknown',
  environment: __APP_ENVIRONMENT__ || 'unknown',
}
